import React, {useState} from 'react';
// material-ui
import {useTheme} from '@mui/material/styles';
import {ButtonBase, Collapse, Stack, Toolbar, Typography} from '@mui/material';
import {Close} from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent/HeaderContent';
import {getHeaderHeight, setHeaderHeight} from '../../../app/store/reducers/ui';
import {activeComponent, activeTab, getOpenComponent} from '../../../app/store/reducers/menu';
import {getDashboardAccount} from '../../../app/store/reducers/dashboard';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
    const theme = useTheme();
    const [showInfobar, setShowInfoBar] = useState(true);

    const headerHeight = useSelector(getHeaderHeight);
    const dashboardAccount = useSelector(getDashboardAccount);
    const openComponent = useSelector(getOpenComponent);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // common header
    const mainHeader = (
        <Toolbar sx={{height: '100%', padding: '0 !important'}}>
            <HeaderContent />
        </Toolbar>
    );

    // app-bar params
    const appBar = {
        position: 'fixed',
        color: 'inherit',
        elevation: 0,
        sx: {
            borderBottom: `1px solid ${theme.palette.divider}`,
            boxShadow: theme.customShadows.default,
            height: headerHeight,
            transition: 'height 0.3s ease-in-out'
        }
    };

    const handleInfoBarAction = () => {
        dispatch(activeTab('crm'));
        if (openComponent !== 'home') {
            dispatch(activeComponent('home'));
            navigate(`/account/${dashboardAccount.sfid}`);
        }
    };

    const handleInfoBarClose = () => {
        setShowInfoBar(false);
        dispatch(setHeaderHeight(110));
    };

    return (
        <>
            <AppBarStyled open={true} {...appBar}>
                <Collapse in={showInfobar}>
                    <Stack
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="center"
                        sx={{height: '48px', padding: '14px 48px', background: '#149CE0'}}
                    >
                        <Typography variant="h5" sx={{color: '#ffffff', fontSize: '1.125rem', fontWeight: 500}}>
                            Looking for invoices? This is now in the CRM tab.{' '}
                            <ButtonBase
                                onClick={handleInfoBarAction}
                                sx={{fontSize: 'inherit', fontWeight: 'inherit', fontFamily: 'inherit', textDecoration: 'underline'}}
                            >
                                Click here to see
                            </ButtonBase>
                        </Typography>
                        <ButtonBase onClick={handleInfoBarClose} sx={{position: 'absolute', top: '12px', right: '48px'}}>
                            <Close sx={{width: '24px', height: '24px', color: '#ffffff'}} />
                        </ButtonBase>
                    </Stack>
                </Collapse>
                {mainHeader}
            </AppBarStyled>
        </>
    );
};

export default Header;
